/* eslint-disable import/prefer-default-export */

/* eslint-disable func-names */
import { callApiServiceCommon } from "../service-common";

const apiLink = process.env.REACT_APP_API;

export function* getListLogCampaign(req) {
  const payload = {
    method: "GET",
    url: `${apiLink}/v2/get-list-log-campaign`,
    params: req,
  };
  return yield callApiServiceCommon(payload);
}

export function* getDataCountViewService() {
  const payload = {
    method: "GET",
    url: `${apiLink}/v2/get-statistic-count-email`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* getListCampaignStaticService(req) {
  let param = {};
  if (req) {
    param = {
      campaign_type: req.campaignType,
    };
  }
  const payload = {
    method: "GET",
    url: `${apiLink}/v2/list-campaigns-email`,
    params: param,
  };
  return yield callApiServiceCommon(payload);
}

export function* getStaticCharService(req) {
  const payload = {
    method: "GET",
    url: `${apiLink}/v2/get-statistic-date-status-count`,
    params: {
      campaign_id: req.campaignId,
      start_date: req.startingTime,
      end_date: req.endingTime,
    },
  };
  return yield callApiServiceCommon(payload);
}
